/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { Space, Modal, Row, Col, Image } from "antd";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import addressActions from "../../../Admin/Address/redux/actions";
import { CustomSelect } from "../CustomSelect";
//import { Format1, Format2, Format3, Format4, Format5, Format6, Format7, Format8, Format9, Format10, BillSupply } from "./Templates";
//import { Format1, Format5, Format7, Format9, BillSupply } from "./Templates";
import { Format1, BillSupply, Letter, Format9, BTST1, SBP, SBL, EX01 } from "./Templates";
import CloseIcon from "../../../../assets/images/icon_menus/Close Button.svg";
import Artboard from "../../../../assets/images/currency/Artboard.png";
import Box from "../../../../assets/images/Box.png";
import colorborder from "../../../../assets/images/colorborder.png";
import { idNamingConversion, storageSetItem } from "../../../../helpers/utilities";
import html2pdf from "html2pdf.js";


const InvoiceModal = React.forwardRef((props, ref) => {
  const { open, link, history, handleClose, title, format = 'format1', preview, type, details } = props;
  // const { languageDetails } = useSelector(state => state.addressReducer);
  const { businessDetails } = useSelector(state => state.homeReducer);
  //const [languageId, setLanguageId] = useState(details?.customer?.languageId);
  const [showNameDesc, setShowNameDesc] = useState('description');
  const pdfExportComponent = useRef(null);
  const formatRef = useRef(null);
  const [invoiceFormat, setInvoiceFormat] = useState('');
  const dispatch = useDispatch();
  const classes = customStyles();
  const closeHandleCancel = () => {
    if (link !== '') {
      history.push(link, type);
    } else {
      handleClose(!open)
    }
  };

  useEffect(() => {
    dispatch({
      type: addressActions.LANGUAGE_DETAILS_START, filter: {
        order: 'id  desc'
      }
    });

  }, []);

  useEffect(() => {
    if (businessDetails && businessDetails?.languageId) {
      //setLanguageId(businessDetails?.languageId);
    }
  }, [businessDetails]);

  useEffect(() => {
    setInvoiceFormat(format);
  }, [format]);

  // const adjustPageBreaks = () => {
  //   const a4Height = 1123; // Approximate A4 height in pixels for html2canvas
  //   const elements = document.querySelectorAll(".avoidPageBreak");

  //   console.log(elements);

  //   elements.forEach((el) => {
  //     const rect = el.getBoundingClientRect();
  //     console.log(rect.height);
  //     console.log(a4Height * 0.75);
  //     if (rect.height > a4Height * 0.75) {
  //       el.classList.add("page-break"); // Move to new page
  //     }
  //   });
  // };


  const previewFormat = () => {
    switch (invoiceFormat) {
      case "format1": return <Format1 ref={formatRef} showNameDesc={showNameDesc} {...props} />;
      case "btst-1": return <BTST1 ref={formatRef} showNameDesc={showNameDesc} {...props} />;
      // case "format2": return <Format1 ref={formatRef} {...props} />;
      // case "format3": return <Format1 ref={formatRef} {...props} />;
      // case "format4": return <Format1 ref={formatRef} {...props} />;
      // case "format5": return <Format5 ref={formatRef} {...props} />;
      // case "format6": return <Format5 ref={formatRef} {...props} />;
      // case "format7": return <Format7 ref={formatRef} {...props} />;
      // case "format8": return <Format7 ref={formatRef} {...props} />;
      case "format9": return <Format9 ref={formatRef} showNameDesc={showNameDesc} {...props} />;
      // case "format10": return <Format9 ref={formatRef} {...props} />;
      case "billSupply": return <BillSupply ref={formatRef} showNameDesc={showNameDesc}  {...props} />;
      case "letter": return <Letter ref={formatRef} showNameDesc={showNameDesc}  {...props} />;
      case "SBP": return <SBP ref={formatRef} showNameDesc={showNameDesc}  {...props} />;
      case "SBL": return <SBL ref={formatRef} showNameDesc={showNameDesc}  {...props} />;
      case "EX01": return <EX01 ref={formatRef} showNameDesc={showNameDesc}  {...props} />;
      default: return <Format1 ref={formatRef} showNameDesc={showNameDesc} {...props} />;
    }
  }

  // const handlePrint = useReactToPrint({
  //   content: () => pdfExportComponent.current,
  //   documentTitle: `${title}`
  // });

  // const handleDownload = async (type = 'download') => {
  //   const content = pdfExportComponent.current;
  //   const doc = new jsPDF('pt', 'px', 'a4');
  //   doc.addFileToVFS('Roboto-Regular.ttf', NormalFont);
  //   doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
  //   doc.addFileToVFS('Roboto-Medium.ttf', MediumFont);
  //   doc.addFont('Roboto-Medium.ttf', 'RobotoMedium', 'normal');
  //   doc.setFont("Roboto");
  //   doc.setFont("RobotoMedium");
  //   formatRef.current.checkHeight('', format);
  //   doc.html(content, {
  //     //fontFaces: fonts,
  //     callback: function (doc) {
  //       if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'qa') {
  //         doc.addImage(Artboard, 'PNG', 100, doc.internal.pageSize.height - 275, 400, 54, '', '', 45);
  //       }
  //       if (type === 'print') {
  //         doc.autoPrint();
  //         window.open(doc.output('bloburl'));
  //       } else {
  //         doc.save(`${title}`);
  //       }
  //     },
  //     autoPaging: 'text',
  //     margin: [10, 10, 10, 10],
  //     html2canvas: {
  //       scale: 0.433
  //     } // change the scale to whatever number you need
  //   });
  //   setTimeout(() => {
  //     formatRef.current.checkHeight('none');
  //   }, 100)
  // };

  const handleDownloadNew = (type = 'download') => {
    const element = pdfExportComponent.current;
    let iv = '';
    html2pdf()
      .from(element)
      .set({
        margin: [10, 5, 10, 5], // [top, left, bottom, right]
        filename: title,
        autoPaging: 'text',
        image: { type: "jpeg", quality: 1.0 },
        html2canvas: {
          scale: 3, // Increase scale for high resolution
          dpi: 300, // Ensure high DPI
          useCORS: true,
          letterRendering: true,
        }, // A4 width in pixels (≈ 210mm)
        pagebreak: { mode: ["css", "legacy"], before: '.page-break', avoid: '.no-break' },
        jsPDF: { unit: "mm", format: "a3", orientation: format === 'SBL' ? "landscape" : "portrait" },
      }).toPdf().get("pdf").then((pdf) => {
        // pdf.setFont("Roboto");
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          if (format !== 'billSupply') {
            if (format === 'SBP' || format === 'SBL' || format === 'letter') {
              pdf.addImage(Box, "PNG", 5, 10, pageWidth - 10, pageHeight - 20); // x, y, width, height
            } else {
              pdf.addImage(colorborder, "PNG", 5, 10, pageWidth - 10, pageHeight - 20); // x, y, width, height
            }
          }

          if (details?.salesInvoice?.serialNo || details?.serialNo) {
            iv = `Invoice Number : ${details?.salesInvoice?.serialNo || details?.serialNo}  - `;
          }

          pdf.setFontSize(10);
          pdf.setTextColor(49, 119, 135);
          //   if (format === 'SBL') {
          //     pdf.text(`${iv} Pg. ${i} | ${totalPages}`, 345, 293);
          //   } else {
          //     pdf.text(`${iv} Pg. ${i} | ${totalPages}`, 226, 415); // Bottom center
          //   }
          //   pdf.setFontSize(10);
          //   pdf.setTextColor(49, 119, 135);
          //   if (format === 'SBL') {
          //     pdf.text('* Powered by YOUNOTE', 5, 293);
          //   } else {
          //     pdf.text('* Powered by YOUNOTE', 5, 415);
          //   }
          const rightTextWidth = pdf.getTextWidth(`${iv} Pg. ${i} | ${totalPages}`);
          pdf.text(`${iv} Pg. ${i} | ${totalPages}`, pageWidth - rightTextWidth - 5, pageHeight - 5);
          pdf.text('* Powered by YOUNOTE', 5, pageHeight - 5);
        }

        if (type === 'print') {
          pdf.autoPrint();
          const blob = pdf.output("blob");
          const formData = new FormData();
          formData.append("mode", "file");        // tell server you're sending PDF
          formData.append("file", blob, "file.pdf");
          fetch(process.env.REACT_APP_EXE_CONNECT_URL, {
            method: "POST",
            body: formData
          }).then(res => res.json()).then(data => { })
            .catch(err => {
              window.open(pdf.output('bloburl', "_blank"));
              console.error(err);
            });
          // window.open(pdf.output('bloburl', "_blank"));
        } else {
          pdf.save(`${title}`);
        }
      });
  }

  const handleDisplayName = (data) => {
    storageSetItem('documentProductView', data);
    setShowNameDesc(data);
  }

  return (
    <Modal title="" open={true} footer={null}
      onCancel={closeHandleCancel}
      width={format === 'SBL' ? 1530 : 1030}
      closable={false}
      className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
      <Row gutter={75} className={classes.invoiceHeader}>
        <Col span={5}>
          <CustomSelect
            lableClasses={clsx(classes.textFieldLableColorCustom)}
            customClasses={clsx(classes.dropDownHighlight, classes.dropDownPointer)}
            details={[{ id: 'name', name: 'Name' }, { id: 'description', name: 'Description' }]}
            name={["Display"]}
            onChange={(e) => handleDisplayName(e.target.value)}
            defaultValue={showNameDesc}
            heads={['id', 'name']}
          />
        </Col>
        <Col span={5}>
          {/* {
            !preview &&
            <CustomSelect
              lableClasses={clsx(classes.textFieldLableColorCustom)}
              customClasses={clsx(classes.dropDownHighlight, classes.dropDownPointer)}
              details={[{ id: 'format1', label: 'Default' },
              { id: 'format2', label: 'Format 2' },
              { id: 'format3', label: 'Format 3' },
              { id: 'format4', label: 'Format 4' },
              { id: 'format5', label: 'Format 5' },
              { id: 'format6', label: 'Format 6' },
              { id: 'format7', label: 'Format 7' },
              { id: 'format8', label: 'Format 8' },
              { id: 'format9', label: 'Format 9' },
              { id: 'format10', label: 'Format 10' }]}
              name={["Invoice Format"]}
              onChange={(e) => setInvoiceFormat(e.target.value)}
              defaultValue={invoiceFormat}
              heads={['id', 'label']}
            />
          } */}
        </Col>
        <Col span={14} className={clsx(classes.textAlignRight, classes.fontSize0)}>
          <Space direction="horizontal" align="center" size={[20, 20]}>
            {
              !preview &&
              <>
                <Button
                  key="confirm"
                  color="primary"
                  variant="contained"
                  id={idNamingConversion('Print', 'common', 'Button')}
                  //onClick={() => format === 'SBL' ? handleDownloadNew('print') : handleDownload('print')}
                  onClick={() => handleDownloadNew('print')}
                  className={clsx(classes.AddMoreBtn)}
                >Print</Button>
                <Button
                  key="save"
                  color="primary"
                  id={idNamingConversion('Download', 'common', 'Button')}
                  variant="contained"
                  //  onClick={() => format === 'SBL' ? handleDownloadNew() : handleDownload()}
                  onClick={() => handleDownloadNew()}
                  className={clsx(classes.modalBtn)}
                >Download</Button>
              </>
            }
            <Image id={idNamingConversion('Close', 'common', 'Icon')} onClick={() => closeHandleCancel()} src={CloseIcon} preview={false} className={classes.cursor} />
          </Space>
        </Col>
      </Row>
      <div ref={pdfExportComponent} style={{ fontFamily: "Roboto" }} className={classes.divToPrint} id={"divToPrint"}>
        {
          (process.env.NODE_ENV === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'qa') &&
          <div className={clsx(classes.divToPrintCommand, "divToPrintCommand")} >
            <Image
              src={Artboard}
              preview={false}
              className={classes.currencyIcon}
            />
          </div>
        }
        {previewFormat()}
      </div>
    </Modal>
  );
});

export default InvoiceModal;
